// extracted by mini-css-extract-plugin
export default {"descriptionToggleButton":"J8-z"};